import React, { useState } from 'react';
import { Description, Dialog, DialogPanel, DialogTitle } from '@headlessui/react'

import Image from '../Image';
import AspectRatioBox from '../AspectRatioBox';

import { BASE_URL, getToken } from '../../utils/api';
import Pagination from '../Pagination';
import usePrevious from '../../hooks/usePrevious';
import { classNames } from '../../utils/utils';

const ImageGrid = ({ perPage, currentSearch, total, images = [], load }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isDownloading, setIsDownloading] = useState(false);
  const [currentPhotoPreview, setCurrentPhotoPreview] = useState(false);

  const dynamicallyDownloadPhoto = href => {
    const link = document.createElement('a');

    link.href = `${BASE_URL}/photos/download/${currentPhotoPreview._id}/${
      currentPhotoPreview._source.name
    }?token=${getToken()}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const previousSearch = usePrevious(currentSearch);

  if (currentSearch !== previousSearch && currentPage !== 1) {
    setCurrentPage(1);
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {images.map(image => (
              <button
                className="w-full outline-none"
                onClick={() => setCurrentPhotoPreview(image)}
                key={image._id}
              >
                <Image
                  src={`${BASE_URL}/photos/thumbnail/xl/${image._id}?token=${getToken()}`}
                  placeholder={`${BASE_URL}/photos/thumbnail/s/${image._id}?token=${getToken()}`}
                  name={image._source.name}
                  source={image._source}
                />
              </button>
        ))}
      </div>
      <div className="flex justify-center">
        <Pagination
          total={total}
          perPage={perPage}
          currentPage={currentPage}
          setPage={page => {
            load(page);
            window.scrollTo(0, 0);
            setCurrentPage(page);
          }}
        />
      </div>
      <Dialog
        open={currentPhotoPreview && true}
        onClose={() => {
          setCurrentPhotoPreview(false);
          setIsDownloading(false);
        }}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/20" aria-hidden="true" />
        {currentPhotoPreview && (
          <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
            <DialogPanel className="max-w-lg">
              <div className="flex flex-col items-center">
                <img
                  src={`${BASE_URL}/photos/thumbnail/xl/${currentPhotoPreview._id}?token=${getToken()}`}
                  alt={currentPhotoPreview._source.name}
                  source={currentPhotoPreview._source}
                  style={{
                    maxHeight: '80vh',
                    maxWidth: '80vh'
                  }}
                />
                <button
                  className={classNames(
                    'bg-white text-sm mt-6 cursor-pointer border-2 px-12 py-4 uppercase font-light tracking-[5px] focus:outline-none hover:bg-gray-100 hover:border-gray-100 transition-colors',
                    isDownloading && 'cursor-not-allowed'
                  )}

                  onClick={() => {
                    setIsDownloading(true);
                    dynamicallyDownloadPhoto();
                  }}
                  disabled={isDownloading}
                >
                  {isDownloading ? 'Downloading...' : 'Download'}
                </button>
              </div>
            </DialogPanel>
          </div>
        )}
      </Dialog>
    </>
  );
};

export default ImageGrid;
